<template>
  <div class="app-forgot-password-wrapper">
    <h2 class="text-3xl text-align-left" v-if="view === 'msisdn'">
      Passwort vergessen
    </h2>
    <h2 class="text-3xl text-align-left" v-else>Passwort zurücksetzen</h2>
    <div class="container-box">
      <div class="content-limiter">
        <ForgotPasswordMsisdn v-if="view === 'msisdn'">
          <template #infotext>
            <slot name="infotextMsisdn"></slot>
          </template>
          <template #label>
            <slot name="labelMsisdn"></slot>
          </template>
          <template #buttonLabel>
            <slot name="buttonLabelMsisdn"></slot>
          </template>
          <template #txtBeforeButton>
            <slot name="txtBeforeButtonMsisdn"></slot>
          </template>
        </ForgotPasswordMsisdn>
      </div>
      <ForgotPasswordChannel v-if="view === 'channel'">
        <template #msisdn><slot name="msisdnChannel"></slot></template>
        <template #btnBack><slot name="buttonLabelChannelBack"></slot></template>
        <template #btnNext><slot name="buttonLabelChannelNext"></slot></template>
      </ForgotPasswordChannel>
      <ForgotPasswordSucceeded v-if="view === 'succeeded'">
        <template #mainTitle><slot name="mainTitleSucceeded"></slot></template>
        <template #mainTitleAlready><slot name="mainTitleAlreadySucceeded"></slot></template>
        <template #mainText><slot name="mainTextSucceeded"></slot></template>
        <template #buttonLabel><slot name="buttonLabelSucceeded"></slot></template>
      </ForgotPasswordSucceeded>
      <ForgotPasswordSucceeded v-if="view === 'succeededSms'">
        <template #mainTitle><slot name="mainTitleSucceededSMS"></slot></template>
        <template #mainTitleAlready><slot name="mainTitleAlreadySucceededSMS"></slot></template>
        <template #mainText><slot name="mainTextSucceededSMS"></slot></template>
        <template #mainTextAdditional><slot name="mainTextSucceededSMSAdditional"></slot></template>
        <template #buttonLabel><slot name="buttonLabelSucceededSMS"></slot></template>
      </ForgotPasswordSucceeded>
      <div :class="['cancel-link-wrapper', { 'content-limiter': view !== 'succeeded' && view !== 'succeededSms' }]">
        <a :href="homeLink" class="link-color text-base cancel-link" title="Abbrechen">Abbrechen</a>
      </div>
    </div>
  </div>
</template>

<script>
import ForgotPasswordMsisdn from './Msisdn.vue'
import ForgotPasswordChannel from './Channel.vue'
import ForgotPasswordSucceeded from './Succeeded.vue'
import { mapGetters, mapMutations } from 'vuex'
import transaction from '@/mixins/transaction'
export default {
  name: 'ForgotPasswordWrapper',
  created: function() {
    if ((this.view === 'succeeded' || this.view === 'succeededSms') && !this.validityPeriod) {
      this.setView('msisdn')
    }
    if (this.view === 'channel') {
      this.setView('msisdn')
    }
    if (this.validityPeriod) {
      this.setAlreadyInitiated(true)
    }
  },
  mixins: [transaction('forgotPassword')],
  methods: {
    ...mapMutations('forgotPassword', ['setView', 'setAlreadyInitiated'])
  },
  computed: {
    ...mapGetters('forgotPassword', ['view', 'validityPeriod'])
  },
  components: {
    ForgotPasswordChannel,
    ForgotPasswordMsisdn,
    ForgotPasswordSucceeded
  },
  props: {
    homeLink: {
      type: String,
      default: '/mein-lidl-connect-v2.html'
    }
  }
}
</script>
